import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';

import { customCheck } from '../../styles/formElementsStyles';

export default function CustomCheckBox(props) {
  const formStyles = customCheck();

  return (
    <Checkbox
      className={formStyles.root}
      color='default'
      {...props}
    />
  );
}
